import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e6b4a012"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "r-loading"
};
const _hoisted_2 = {
  class: "r-loading-main"
};
const _hoisted_3 = {
  class: "loader-inner ball-beat"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
import { computed } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'RequestLoading',
  props: {
    // 是否暂时不渲染动画
    hideRound: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const showRound = computed(() => {
      return !props.hideRound;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_7, 512), [[_vShow, _unref(showRound)]])])]);
    };
  }
});